import { render } from "./nicDelete.vue?vue&type=template&id=dff0a67e"
import script from "./nicDelete.vue?vue&type=script&lang=js"
export * from "./nicDelete.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__